import SButton from "components/Common/Button"
import TableContainer from "components/newTables/TableContainer"
import React, { useMemo } from "react"
import { useHistory } from "react-router-dom"

const Table = ({ data, page, size, count, params, setParams }) => {
  const history = useHistory()
  const listDataTable = useMemo(() => {
    if (!data?.content) return []
    return data?.content.map((v, i) => ({
      id: v.id,
      no: v.no,
      name: v.name,
      authority: v?.authority || "-",
      email: v.email,
      craftsmanTypes: v.craftsmanTypes,
    }))
  }, [data?.content])

  const columns = useMemo(
    () => [
      {
        Header: "管理者番号",
        accessor: "no",
        disableSortBy: true,
      },
      {
        Header: "管理者名",
        accessor: "name",
        disableSortBy: true,
      },
      {
        Header: "権限",
        accessor: "authority",
        disableSortBy: true,
      },
      {
        Header: "職人種類",
        accessor: "craftsmanTypes",
        disableSortBy: true,
        Cell: props => {
          return <div>{props.row.values.craftsmanTypes.join(", ")}</div>
        },
      },
      {
        Header: "メールアドレス",
        accessor: "email",
        disableSortBy: true,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(`/administrator/${cell.row.original.id}`)
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  return data?.content?.length === 0 ? (
    <h3 className="text-center">No Data to Display</h3>
  ) : (
    <TableContainer
      data={listDataTable}
      columns={columns}
      page={page}
      size={size}
      count={count}
      params={params}
      setParams={setParams}
      pagination
    />
  )
}

export default Table
